import React, { useContext } from 'react';
import Slider from '../../../components/Slider/Slider';
import ProductPageContext from '../../../contexts/ProductPageContext';

const OutfitCarousel = ({ children }) => {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState;

  if (!children || (Array.isArray(children) && children.length === 0)) return null;

  return (
    <div className="outfit-carousel-container">
      <div className="outfit-carousel-container-header">
        <h2 className="h1">
          {tmntData?.pdpOutfittingWearItWith?.value}
        </h2>
      </div>
      <div className="outfit-carousel-slider-wrapper">
        <Slider
          isScrollAllowed
          slides={children}
          slideMagnitude={1}
          minimumSlideWidth={285}
          isInfinite={false}
          showControls={false}
          label="Outfit Carousel"
        />
      </div>
    </div>
  );
};

export default OutfitCarousel;
